/* eslint-disable no-await-in-loop */
/* eslint-disable no-param-reassign */
import { message } from 'antd';
import axios from 'axios';
import moment from 'moment';

import Utils from '../../../Assets/Scripts/Utils';
import ScheduleUtils from '../../../Components/Schedule/ScheduleUtils';
import { api } from '../../../Services/axiosService';

class SchedulingFunctions {
  static notifyWrongTrainingType(trainingType) {
    message.warning(`Este recurso não aceita este Tipo de Treinamento (${trainingType})!`);
  }

  static generateResourceSlots(pResources, pCtResourcesSlots) {
    const dateKeys = Object.keys(pResources);

    dateKeys.forEach((dateKey) => {
      const ctResourceList = [];
      pResources[dateKey]?.forEach(
        ({ id, validSlots, additionalSlots, trainingType, isLastColumn }) => {
          const workTime = 10;
          const slotDuration = 2;
          const totalSlots = workTime / slotDuration;

          const resourceSlots = [];
          let startHour = new Date(2023, 7, 24, 8, 0, 0, 0);
          for (let i = 0; i < totalSlots; i += 1) {
            startHour = new Date(moment(startHour).add(1, 'seconds'));
            const endHour = new Date(
              moment(startHour).subtract(2, 'seconds').add(slotDuration, 'hours')
            );

            resourceSlots.push({
              type: trainingType,
              slotStart: startHour,
              slotEnd: endHour,
              isValid: validSlots > 0 || additionalSlots >= 0,
              isLastColumn,
              isAdditional: validSlots === 0 && additionalSlots >= 0,
            });
            startHour = new Date(moment(endHour).add(1, 'seconds'));

            if (validSlots > 0) {
              validSlots -= 1;
            }
            if (validSlots === 0 && additionalSlots >= 0) {
              additionalSlots -= 1;
            }
          }

          ctResourceList[id] = resourceSlots;
        }
      );

      pCtResourcesSlots[dateKey] = ctResourceList;
    });
  }

  static calculateResourceSlots(pResources, pTrainingCenter, pSlots, pStartDate, pEndDate) {
    const {
      ctQtyColumns,
      ctQtySlots,
      inCompanyQtyColumns,
      inCompanyQtySlots,
      eadQtyColumns,
      eadQtySlots,
      serviceQtyColumns,
      serviceQtySlots,
    } = pTrainingCenter;
    const diff = moment(pEndDate).diff(pStartDate, 'days');
    const dateKeys = [];

    if (diff > 0) {
      for (let i = 0; i < 7; i += 1) {
        dateKeys.push(moment(pStartDate).add(i, 'days').format('YYYY-MM-DD'));
      }
    } else {
      dateKeys.push(moment(pStartDate).format('YYYY-MM-DD'));
    }

    dateKeys.forEach((dateKey) => {
      const resourceList = [];
      let ctQtySlotsCopy = ctQtySlots;
      let inCompanyQtySlotsCopy = inCompanyQtySlots;
      let eadQtySlotsCopy = eadQtySlots;
      let serviceQtySlotsCopy = serviceQtySlots;

      for (let i = 1; i <= ctQtyColumns; i += 1) {
        resourceList.push({
          id: resourceList.length + 1,
          trainingTypeId: 1,
          trainingType: 'CT',
          slotType: 'CT',
          validSlots: 0,
          additionalSlots: 0,
          isLastColumn: i % ctQtyColumns === 0,
        });
      }

      for (let i = 1; i <= inCompanyQtyColumns; i += 1) {
        resourceList.push({
          id: resourceList.length + 1,
          trainingTypeId: 2,
          trainingType: 'In Company',
          slotType: 'In Company',
          validSlots: 0,
          additionalSlots: 0,
          isLastColumn: i % inCompanyQtyColumns === 0,
        });
      }

      for (let i = 1; i <= eadQtyColumns; i += 1) {
        resourceList.push({
          id: resourceList.length + 1,
          trainingTypeId: 3,
          trainingType: 'EAD',
          slotType: 'EAD',
          validSlots: 0,
          additionalSlots: 0,
          isLastColumn: i % eadQtyColumns === 0,
        });
      }

      for (let i = 1; i <= serviceQtyColumns; i += 1) {
        resourceList.push({
          id: resourceList.length + 1,
          trainingTypeId: 1,
          trainingType: 'CT',
          slotType: 'Service',
          validSlots: 0,
          additionalSlots: 0,
          isLastColumn: i % serviceQtyColumns === 0,
        });
      }

      const additionalSlots = pSlots?.filter(
        ({ approved, date }) =>
          approved && moment(date).add(4, 'hours').format('YYYY-MM-DD') === dateKey
      );

      let additionalCtSlots = additionalSlots?.filter(({ type }) => type === 'CT')?.length ?? 0;
      let additionalInCompanySlots =
        additionalSlots?.filter(({ type }) => type === 'In Company')?.length ?? 0;
      let additionalEadSlots = additionalSlots?.filter(({ type }) => type === 'EAD')?.length ?? 0;
      let additionalServiceSlots =
        additionalSlots?.filter(({ type }) => type === 'Service')?.length ?? 0;

      while (ctQtySlotsCopy > 0 || inCompanyQtySlotsCopy > 0 || eadQtySlotsCopy > 0) {
        // eslint-disable-next-line no-loop-func
        resourceList?.forEach((item) => {
          switch (item.slotType) {
            case 'CT':
              if (ctQtySlotsCopy > 0) {
                item.validSlots += 1;
                ctQtySlotsCopy -= 1;
              }
              if (item.validSlots + item.additionalSlots < 5) {
                if (additionalCtSlots > 0) {
                  item.additionalSlots += 1;
                  additionalCtSlots -= 1;
                }
              }
              break;
            case 'In Company':
              if (inCompanyQtySlotsCopy > 0) {
                item.validSlots += 1;
                inCompanyQtySlotsCopy -= 1;
              }
              if (item.validSlots + item.additionalSlots < 5) {
                if (additionalInCompanySlots > 0) {
                  item.additionalSlots += 1;
                  additionalInCompanySlots -= 1;
                }
              }
              break;
            case 'EAD':
              if (eadQtySlotsCopy > 0) {
                item.validSlots += 1;
                eadQtySlotsCopy -= 1;
              }
              if (item.validSlots + item.additionalSlots < 5) {
                if (additionalEadSlots > 0) {
                  item.additionalSlots += 1;
                  additionalEadSlots -= 1;
                }
              }
              break;
            case 'Service':
              if (serviceQtySlotsCopy > 0) {
                item.validSlots += 1;
                serviceQtySlotsCopy -= 1;
              }
              if (item.validSlots + item.additionalSlots < 5) {
                if (additionalServiceSlots > 0) {
                  item.additionalSlots += 1;
                  additionalServiceSlots -= 1;
                }
              }
              break;
            default:
              break;
          }
        });
      }

      pResources[dateKey] = resourceList;
    });
  }

  static async fetchBitrixProducts(pBitrixUrl, pSetBitrixProducts) {
    try {
      const productOptions = [];
      const { data: firstResponse } = await axios.get(
        `${pBitrixUrl}crm.product.list?filter[ACTIVE]=Y&start=0&select[]=*`
      );

      const totalCount = firstResponse.total;
      const batchCmds = {};
      const batchCount = Math.ceil(totalCount / 50);

      for (let i = 0; i < batchCount; i += 1) {
        const start = i * 50;
        const cmdKey = `cmd${start}`;
        batchCmds[cmdKey] = `crm.product.list?filter[ACTIVE]=Y&start=${start}&select[]=*`;
      }

      const response = await axios.post(`${pBitrixUrl}batch`, { cmd: batchCmds });

      if (response && response?.data) {
        Object.values(response.data?.result?.result).forEach((result) => {
          result.forEach((product) => {
            productOptions.push({
              label: product.NAME,
              value: product.NAME,
              id: product.ID,
              measure: product.MEASURE,
              measurePrice: product.PROPERTY_432?.value,
              minQuantity: product.PROPERTY_392?.value,
              description: product.DESCRIPTION,
              practicalDaysPerClass: product.PROPERTY_538?.value,
              practicalTimePerClass: product.PROPERTY_542?.value,
              theoreticalDaysPerClass: product.PROPERTY_564?.value,
              theoreticalTimePerClass: product.PROPERTY_562?.value,
              inCompanyDaysPerClass: product.PROPERTY_568?.value,
              inCompanyTimePerClass: product.PROPERTY_566?.value,
              eadDays: product.PROPERTY_594?.value,
              resourceGroup: product.PROPERTY_546?.value,
              disabled: product.ID === '19890',
            });
          });
        });

        const concatOptions = productOptions.flat();
        pSetBitrixProducts(concatOptions);
      }
    } catch (error) {
      Utils.logError(error);
    }
  }

  static getOverviewData(pAppointments, pSetOverview, pStartDate, pEndDate) {
    const tasksOverview = pAppointments.filter(({ startDate }) => {
      const dateFilter = moment(new Date(startDate)).format('YYYY-MM-DDTHH:mm:ss');
      return dateFilter > pStartDate && dateFilter <= pEndDate;
    });

    const tasksByProduct = Utils.groupBy(tasksOverview, 'text');
    const scheduledTasks = tasksOverview?.map(({ id }) => id);

    const overviewList = [];
    Object.keys(tasksByProduct).forEach((product) => {
      const scheduledClasses = tasksByProduct[product].filter(({ id }) =>
        scheduledTasks?.includes(id)
      );

      // Determina a data de início mais precoce para o produto atual
      const startDates = scheduledClasses.map(({ startDate }) => startDate);
      const startDate = startDates.reduce((a, b) => (a < b ? a : b), startDates[0]);

      // Agrupa Turmas por Start Date
      let totalClassesSlot = 0;
      const scheduledClassesByDate = Utils.groupBy(scheduledClasses, 'startDate');
      Object.keys(scheduledClassesByDate).forEach((key) => {
        const resourceIdList = scheduledClassesByDate[key].map(({ resourceId }) => resourceId);
        const uniqueResourceIdList = resourceIdList.filter(
          (value, index, self) => self.indexOf(value) === index
        );
        totalClassesSlot += uniqueResourceIdList.length;
      });

      const customProductList = ScheduleUtils.getCustomProductList();
      const ctStudents = scheduledClasses
        .filter(
          ({ resource, product }) => resource === 'CT' && !customProductList.includes(product.id)
        )
        .map(({ qtyStudentsPerClass }) => qtyStudentsPerClass)
        .reduce((startVal, nextVal) => startVal + nextVal, 0);

      const inCompanyStudents = scheduledClasses
        .filter(
          ({ resource, product }) =>
            resource === 'In Company' && !customProductList.includes(product.id)
        )
        .map(({ qtyStudentsPerClass }) => qtyStudentsPerClass)
        .reduce((startVal, nextVal) => startVal + nextVal, 0);

      const eadStudents = scheduledClasses
        .filter(
          ({ resource, product }) => resource === 'EAD' && !customProductList.includes(product.id)
        )
        .map(({ qtyStudentsPerClass }) => qtyStudentsPerClass)
        .reduce((startVal, nextVal) => startVal + nextVal, 0);

      overviewList.push({
        product,
        classes: totalClassesSlot,
        ctStudents,
        inCompanyStudents,
        eadStudents,
        startDate, // Adiciona a data de início mais precoce ao objeto
      });
    });
    pSetOverview(overviewList);
  }

  static getResumeData(pAppointments, pSetResume, pStartDate, pEndDate) {
    const tasksOverview = pAppointments.filter(({ startDate }) => {
      const dateFilter = moment(new Date(startDate)).format('YYYY-MM-DDTHH:mm:ss');
      return dateFilter > pStartDate && dateFilter <= pEndDate;
    });

    const resumeList = tasksOverview.map((item) => ({
      ...item,
      key: item.id,
      company: item.dealClient,
      productName: item.product.name,
      stageName: item.stage.name,
      students: item.qtyStudentsPerClass,
      type: item.resource,
      isShared: item.sharedTraining,
      stageColor: item.stage.color,
    }));
    pSetResume(resumeList);
  }

  static async sendNotificationToApprovers() {
    try {
      const receiversList = await api
        .get(
          '/User?filters[0].Field=IsApprover&filters[0].Condition=BOOL.EQUAL&filters[0].Value=true'
        )
        .then((res) => res.data);

      for (let i = 0; i < receiversList.length; i += 1) {
        const userData = JSON.parse(localStorage.getItem('conecta__userData') ?? '{}');
        const ctData = JSON.parse(localStorage.getItem('conecta__scheduleData') ?? '{}');

        const data = {
          sourceId: userData?.id,
          sourceEvent: 'SlotApproval',
          notification: {
            userId: receiversList[i].id,
            title: 'Solicitação de slots',
            body: `${userData?.name} solicitou novos slots no CT ${ctData?.trainingCenter}. Você pode clicar no botão de redirecionamento para ir até a tela de Agendamento, podendo Aprovar ou Negar as solicitações.`,
            redirectUrlPathWeb: `/Agenda/Agendamento/OpenNewSlots/${ctData?.maxCapacityPerDay}/${ctData?.trainingCenter}/${ctData?.trainingCenterId}`,
          },
        };

        await api.post('/Notification', data).then((res) => res);
      }
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Ocorreu um erro ao notificar os Aprovadores!');
    }
  }

  static async sendNotificationToInstructor(date, instructorUserId) {
    try {
      const userData = JSON.parse(localStorage.getItem('conecta__userData') ?? '{}');

      const data = {
        sourceId: userData?.id,
        sourceEvent: 'InstructorBooking',
        notification: {
          userId: instructorUserId,
          title: 'Reserva de Agenda',
          body: `Novo reserva recebida para o dia (${date}). Você pode clicar no botão de redirecionamento para ir até a agenda!`,
          redirectUrlPathWeb: `/Agenda/Instrutor`,
          redirectUrlPathMobile: `Agenda`,
        },
      };

      await api.post('/Notification', data).then((res) => res);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Ocorreu um erro ao notificar o Instrutor sobre a reserva!');
    }
  }

  static async sendDeletionNotificationToInstructor(date, instructorUserId) {
    try {
      const userData = JSON.parse(localStorage.getItem('conecta__userData') ?? '{}');

      const data = {
        sourceId: userData?.id,
        sourceEvent: 'InstructorBookingDeletion',
        notification: {
          userId: instructorUserId,
          title: 'Reserva de Agenda Removida',
          body: `Uma reserva para o dia (${date}) foi removida. Você pode clicar no botão de redirecionamento para verificar a agenda!`,
          redirectUrlPathWeb: `/Agenda/Instrutor`,
          redirectUrlPathMobile: `Agenda`,
        },
      };

      await api.post('/Notification', data).then((res) => res);
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Ocorreu um erro ao notificar o Instrutor sobre a remoção da reserva!');
    }
  }

  static async sendNotificationToOperators(newTaskData, oldTaskData) {
    try {
      const stagesToNotify = [
        3, // 3 = Confirmado
        10, // 10 = Pré-Reservado
        12, // 12 = Reservado
        13, // 13 = Reservado Sem Confirmação
      ];

      if (stagesToNotify.includes(newTaskData.stage.id)) {
        // Notifica Instrutor
        if (!oldTaskData?.oldMainInstructorId && newTaskData?.mainInstructor?.userId) {
          await ScheduleUtils.sendPushNotification(
            newTaskData,
            'TaskReceived',
            'mainInstructor',
            newTaskData.mainInstructor.userId
          );
        }

        if (
          (oldTaskData?.oldMainInstructorId && !newTaskData?.mainInstructor?.userId) ||
          (oldTaskData?.oldMainInstructorId &&
            oldTaskData?.oldMainInstructorId !== newTaskData?.mainInstructor?.userId)
        ) {
          await ScheduleUtils.sendPushNotification(
            newTaskData,
            'TaskRemoved',
            'mainInstructor',
            oldTaskData.oldMainInstructorId
          );

          if (newTaskData?.mainInstructor?.userId) {
            await ScheduleUtils.sendPushNotification(
              newTaskData,
              'TaskReceived',
              'mainInstructor',
              newTaskData.mainInstructor.userId
            );
          }
        }

        // Notifica Instrutor Auxiliar
        if (!oldTaskData?.oldAssistantInstructorId && newTaskData?.assistantInstructor?.userId) {
          await ScheduleUtils.sendPushNotification(
            newTaskData,
            'TaskReceived',
            'assistantInstructor',
            newTaskData.assistantInstructor.userId
          );
        }

        if (
          (oldTaskData?.oldAssistantInstructorId && !newTaskData?.assistantInstructor?.userId) ||
          (oldTaskData?.oldAssistantInstructorId &&
            oldTaskData?.oldAssistantInstructorId !== newTaskData?.assistantInstructor?.userId)
        ) {
          await ScheduleUtils.sendPushNotification(
            newTaskData,
            'TaskRemoved',
            'assistantInstructor',
            oldTaskData.oldAssistantInstructorId
          );

          if (newTaskData?.assistantInstructor?.userId) {
            await ScheduleUtils.sendPushNotification(
              newTaskData,
              'TaskReceived',
              'assistantInstructor',
              newTaskData.assistantInstructor.userId
            );
          }
        }

        // Notifica Motoristas
        const oldDriverList = oldTaskData.driverList || [];
        const newDriverList = newTaskData.driverList || [];

        // Extrai os IDs dos motoristas dos objetos
        const oldDriverIds = oldDriverList.map((driver) => driver.userId);
        const newDriverIds = newDriverList.map((driver) => driver.userId);

        const removedDriverIds = [];
        const addedDriverIds = [];

        // Monta lista de Motoristas Removidos
        oldDriverIds.forEach((oldId) => {
          const driver = newDriverIds.find((newId) => newId === oldId);

          if (!driver) {
            removedDriverIds.push(oldId);
          }
        });

        // Monta lista de Novos Motoristas
        newDriverIds.forEach((newId) => {
          const driver = oldDriverIds.find((oldId) => oldId === newId);

          if (!driver) {
            addedDriverIds.push(newId);
          }
        });

        for (let index = 0; index < addedDriverIds?.length; index += 1) {
          await ScheduleUtils.sendPushNotification(
            newTaskData,
            'TaskReceived',
            'driver',
            addedDriverIds[index]
          );
        }

        for (let index = 0; index < removedDriverIds?.length; index += 1) {
          await ScheduleUtils.sendPushNotification(
            newTaskData,
            'TaskRemoved',
            'driver',
            removedDriverIds[index]
          );
        }
      }

      newTaskData.oldMainInstructorId = newTaskData?.mainInstructor?.userId;
      newTaskData.oldAssistantInstructorId = newTaskData?.assistantInstructor?.userId;
      newTaskData.oldDriverId = newTaskData?.driver?.userId;
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao tentar notificar os operadores!');
    }
  }

  /**
   * Busca a disponibilidade dos instrutores de um centro de treinamento específico.
   * @param {Array} instructorOptions - Lista de instrutores disponíveis.
   * @param {Date} startDate - Data de início para verificar disponibilidade.
   * @param {Date} endDate - Data de fim para verificar disponibilidade.
   * @returns {Promise<Array>} - Promessa com a lista de disponibilidade dos instrutores.
   */
  static async fetchInstructorsAvailability(instructorOptions, startDate, endDate) {
    try {
      const operatorIdList = instructorOptions?.map((instructor) => ({
        UserId: instructor.id,
        CompanyId: instructor.company.id,
      }));

      let response = [];
      if (operatorIdList?.length > 0) {
        const availabilityModel = {
          Start: moment(new Date(startDate).setHours(0, 0, 0, 1)).format('YYYY-MM-DDTHH:mm:ss'),
          Finish: moment(new Date(endDate).setHours(23, 59, 59, 99)).format('YYYY-MM-DDTHH:mm:ss'),
          OperatorIdList: operatorIdList,
        };

        response = await api
          .post('/Task/InstructorsAvailability', availabilityModel)
          .then((res) => res.data);
      }

      return response;
    } catch (error) {
      message.error('Oops. Algo deu errado ao buscar a Disponibilidade dos Instrutores!');
      throw error;
    }
  }

  static addSlotClassId(task, foundAppointments) {
    if (foundAppointments.length > 0) {
      const [appointment] = foundAppointments;
      task.slotClassId = appointment.slotClassId;
    } else {
      task.slotClassId = Utils.generateUUID();
    }
  }

  static evaluateOccupiedSlotShare(data, firstAppointment) {
    const isCustomProduct =
      ScheduleUtils.getCustomProductList().includes(data.product?.id) || data.group?.id === 24;

    if (!data.sharedTraining && !isCustomProduct) {
      return 'Este Treinamento não é compartilhado!';
    }

    if (
      !firstAppointment.sharedTraining &&
      !firstAppointment.acceptSharedTraining &&
      !isCustomProduct
    ) {
      return 'Este Slot não é compartilhado!';
    }

    return null;
  }

  static formatAppointmmentInfo(
    data,
    ctResources,
    taskAcceptanceDeadline,
    ctResourcesSlots,
    trainingsOptions
  ) {
    const resource = ctResources?.find(({ id }) => id === data.resourceId);
    const group = trainingsOptions?.find(({ id }) => id === data.group.id);

    data.group = group;
    data.resource = resource.trainingType;
    data.resourceId = resource.id;
    data.startDate = new Date(moment(data.startDate).add(1, 'seconds'));
    data.acceptanceDeadline = new Date(moment(data.startDate).add(taskAcceptanceDeadline, 'hours'));

    const dateKey = moment(data.startDate).format('YYYY-MM-DD');

    // eslint-disable-next-line array-callback-return, consistent-return
    const resourceSlot = ctResourcesSlots[dateKey][resource?.id]?.find((resource) => {
      const startDt = new Date(data.startDate);
      const endDt = new Date(data.endDate);
      const slotStartDt = new Date(resource.slotStart);
      const slotEndDt = new Date(resource.slotEnd);

      const slotStartHour = Utils.createSafeDate(startDt, slotStartDt);
      const slotEndHour = Utils.createSafeDate(endDt, slotEndDt);

      if (startDt >= slotStartHour && startDt <= slotEndHour) {
        return resource;
      }
    });

    if (!resourceSlot?.isValid) {
      const errMessage = 'Oops! Slot inválido, contate um administrador do sistema.';
      Utils.logError(errMessage);
      message.error(errMessage);
      return true;
    }

    const slotStart = moment(resourceSlot.slotStart);
    const slotStartDate = slotStart
      .set('year', data.startDate.getFullYear())
      .set('month', data.startDate.getMonth())
      .set('date', data.startDate.getDate());

    const slotStartFormatted = slotStartDate.toDate();

    const slotTotalTime = 2;
    const slotEndFormatted = slotStartDate
      .clone()
      .add(slotTotalTime, 'hours')
      .subtract(2, 'seconds')
      .toDate();

    if (resource.trainingTypeId !== data.trainingTypeId) {
      this.notifyWrongTrainingType(data.trainingType);
      return true;
    }

    data.startDate = slotStartFormatted;
    data.endDate = slotEndFormatted;
    return false;
  }

  static mapTimeFields(task) {
    const timeFields = [
      'startDate',
      'startHour',
      'endHour',
      'boardingHour',
      'arrivalHour',
      'date',
      'dateScheduling',
      'dateUploadAcceptTerm2',
      'confirmationDate',
      'billingDeadlineDate',
      'invoiceEmissionDate',
    ];

    timeFields.forEach((field) => {
      task[field] = task[field] ? moment(task[field]) : null;
    });
  }

  static mapFormData(task) {
    if (task.mainInstructor) {
      task.mainInstructor = {
        ...task.mainInstructor,
        label: task.mainInstructor.userName?.toUpperCase(),
        value: task.mainInstructor.userId,
      };
    }

    if (task.assistantInstructor) {
      task.assistantInstructor = {
        ...task.assistantInstructor,
        label: task.assistantInstructor.userName?.toUpperCase(),
        value: task.assistantInstructor.userId,
      };
    }

    if (task.transportCompany) {
      task.transportCompany = {
        ...task.transportCompany,
        label: task.transportCompany.commercialName,
        value: task.transportCompany.id,
      };
    }

    if (task.driverList) {
      task.driverList = task.driverList.map((item) => ({
        ...item,
        value: item.userId,
        label: item.userName,
      }));
    }

    if (!task.driverList) {
      task.driverList = [];
    }

    if (task.invoiceIssuer) {
      task.invoiceIssuer = {
        ...task.invoiceIssuer,
        label: task.invoiceIssuer.name,
        value: task.invoiceIssuer.id,
      };
    }

    if (task.reasonNoBilling) {
      task.reasonNoBilling = {
        ...task.reasonNoBilling,
        label: task.reasonNoBilling.name,
        value: task.reasonNoBilling.id,
      };
    }

    if (task.group) {
      task.group = {
        ...task.group,
        label: task.group.name,
        value: task.group.id,
      };
    }
  }

  static hasAccess(fieldsPermissions, permissionNames) {
    return permissionNames.some((name) => fieldsPermissions?.[name]?.access !== 0);
  }

  /**
   * Resolve o resourceId de exibição na grade atual. Puro: não muta tipo nem grava.
   * @param {number|null} storedResourceId
   * @param {string|object} storedType resource primeiro; se vazio, trainingType
   * @param {Array<{id: number, slotType: string}>} columns
   * @returns {{kind: 'aligned'|'remapped'|'no-destination'|'keep', resourceId: number|null}}
   */
  static resolveAgendaResourceId(storedResourceId, storedType, columns) {
    const normalizedType = SchedulingFunctions.normalizeAgendaStoredType(storedType);
    if (!normalizedType) {
      return { kind: 'keep', resourceId: storedResourceId };
    }

    const own = SchedulingFunctions.collectOwnAgendaColumns(columns, normalizedType);
    if (own.length === 0) {
      return { kind: 'no-destination', resourceId: null };
    }

    if (SchedulingFunctions.isAlignedAgendaColumn(columns, storedResourceId, normalizedType)) {
      return { kind: 'aligned', resourceId: storedResourceId };
    }

    return SchedulingFunctions.remapDisplacedAgendaResourceId(storedResourceId, own);
  }

  static readAgendaStoredTypeSource(storedType) {
    if (storedType && typeof storedType === 'object' && !Array.isArray(storedType)) {
      return storedType.resource || storedType.trainingType;
    }

    return storedType;
  }

  static normalizeAgendaStoredType(storedType) {
    const typeSource = SchedulingFunctions.readAgendaStoredTypeSource(storedType);
    if (typeSource == null || typeSource === '') {
      return null;
    }

    const trimmedType = String(typeSource).trim();
    if (trimmedType === 'Serviço') {
      return 'Service';
    }

    const validSlotTypes = ['CT', 'In Company', 'EAD', 'Service'];
    return validSlotTypes.includes(trimmedType) ? trimmedType : null;
  }

  static collectOwnAgendaColumns(columns, normalizedType) {
    const columnList = Array.isArray(columns) ? columns : [];
    return columnList
      .filter((column) => column.slotType === normalizedType)
      .sort((leftColumn, rightColumn) => leftColumn.id - rightColumn.id);
  }

  static parseStoredAgendaResourceId(storedResourceId) {
    if (storedResourceId === null || storedResourceId === undefined || storedResourceId === '') {
      return NaN;
    }

    return Number(storedResourceId);
  }

  static isAlignedAgendaColumn(columns, storedResourceId, normalizedType) {
    const parsedId = SchedulingFunctions.parseStoredAgendaResourceId(storedResourceId);
    if (!Number.isFinite(parsedId)) {
      return false;
    }

    const columnList = Array.isArray(columns) ? columns : [];
    return columnList.some(
      (column) => column.id === parsedId && column.slotType === normalizedType
    );
  }

  static remapDisplacedAgendaResourceId(storedResourceId, own) {
    const qtyT = own.length;
    const parsedId = SchedulingFunctions.parseStoredAgendaResourceId(storedResourceId);

    if (Number.isFinite(parsedId) && parsedId >= 1 && parsedId <= qtyT) {
      return { kind: 'remapped', resourceId: own[parsedId - 1].id };
    }

    if (qtyT === 1) {
      return { kind: 'remapped', resourceId: own[0].id };
    }

    return { kind: 'no-destination', resourceId: null };
  }
}

export default SchedulingFunctions;
